// page name
export const OVERVIEW = 'overview';
export const EPOCHS = 'epochs';
export const LAYERS = 'layers';
export const TXNS = 'txs';
export const REWARDS = 'rewards';
export const ACCOUNTS = 'accounts';
export const ACCOUNTS_TXNS = 'accounts-txs';
export const SMART_WALLET = 'apps';
export const SMESHER = 'smeshers';
export const ATXS = 'atxs';
export const BLOCKS = 'blocks';
export const NOT_FOUND = 'not-found';

// status
export const STATUS_LOADING = 'loading';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';

// TXS rate
export const USD_RATE = 1;

export const MALFEASANCE = 'malfeasance';
